export const models = [
	{
		name: 'goku',
		title: 'Goku',
		file: './goku/scene.gltf',
		scale: 1.5,
		desc: 'Goku from the Dragon Ball universe in a fighting stance',
		price: `(ETH)  8`,
		prog: 'Blender',
	},
	{
		name: 'ape',
		title: 'Ape',
		file: './ape/scene.gltf',
		scale: 2,
		desc: `Apes strong together. 'nuff said`,
		price: `(ETH)  6`,
		prog: 'Blender',
	},
	{
		name: 'spiderman',
		title: 'Spider-Man',
		file: './spiderman/scene.gltf',
		scale: 1,
		desc: 'Spider-man on his day off enjoying the day',
		price: `(ETH)  8`,
		prog: 'Blender',
	},
	{
		name: 'porsche',
		title: '1975 Porsche 911',
		file: './porsche/scene.gltf',
		scale: 1,
		desc: 'Black Porsche 911 from the year 1975',
		price: `(ETH)  20`,
		lights: true,
		prog: 'Blender',
	},
	{
		name: 'alfa',
		title: 'Alfa Romeo',
		file: './alfa/scene.gltf',
		scale: 12,
		desc: 'Coupe Alfa Romeo',
		price: `(ETH)  12`,
		lights: true,
		prog: 'Blender',
	},
	{
		name: 'mercedes',
		title: 'Mercedes Hovercraft',
		file: './mercedes/scene.gltf',
		scale: 3,
		desc: 'Hovercraft made by Mercedes',
		price: `(ETH)  12`,
		lights: true,
		prog: 'Blender',
	},
]
